define('Facets.FacetedNavigationItemCategory.View.Extension', [
  'Facets.FacetedNavigationItemCategory.View',
  'underscore'
], function (View, _) {
  'use strict';

  return _.extend(View.prototype, {
    getContext: _.wrap(View.prototype.getContext, function (fn, args) {
      // Sorting categories side bar by name
      this.categories = this.categories && _.sortBy(this.categories, 'name');
      var context = fn.apply(this, _.toArray(arguments).slice(1));

      return _.extend(context, {
        showCurrentFacet: true,
        currentLink: this.model.get('fullurl'),
        currentLabel: this.model.get('name'),
        currentLabelDisplayName: this.model.get('name')
      });
    })
  });
});
